import { isEqual, omit } from 'lodash';
import { useRef } from 'react';

import { Json } from '@/lib/types';

export const useMemoizeDataQueryVariables = <T extends Record<string, Json>>(
  variables: T,
  ignoredVariables = ['options'],
) => {
  const previousVariablesRef = useRef(variables);
  if (
    !isEqual(
      // eslint-disable-next-line react-compiler/react-compiler
      omit(previousVariablesRef.current, ignoredVariables),
      omit(variables, ignoredVariables),
    )
  ) {
    // eslint-disable-next-line react-compiler/react-compiler
    previousVariablesRef.current = variables;
    return variables;
  }
  // eslint-disable-next-line react-compiler/react-compiler
  return previousVariablesRef.current;
};
